"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
const _withScopeId = n => ((0, vue_1.pushScopeId)("data-v-0169129b"), n = n(), (0, vue_1.popScopeId)(), n);
const _hoisted_1 = { class: "tab-layout" };
const _hoisted_2 = { class: "tab-layout-router" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_1.createElementVNode)("p", null, "请注意，当前用户无当前页面权限！", -1));
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_1.createElementVNode)("p", null, "请注意，当前页面为正在开发中页面，请勿操作！", -1));
const _hoisted_6 = [
    _hoisted_5
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LogoView = (0, vue_1.resolveComponent)("LogoView");
    const _component_HeaderView = (0, vue_1.resolveComponent)("HeaderView");
    const _component_SiderView = (0, vue_1.resolveComponent)("SiderView");
    const _component_router_view = (0, vue_1.resolveComponent)("router-view");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.dependLoad === 'end')
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, [
                (0, vue_1.createVNode)(_component_LogoView, {
                    style: (0, vue_1.normalizeStyle)(_ctx.logoStyle)
                }, null, 8, ["style"]),
                (0, vue_1.createVNode)(_component_HeaderView, {
                    style: (0, vue_1.normalizeStyle)(_ctx.headerStyle)
                }, null, 8, ["style"]),
                (0, vue_1.createVNode)(_component_SiderView, {
                    style: (0, vue_1.normalizeStyle)(_ctx.siderStyle)
                }, null, 8, ["style"])
            ], 64))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createElementVNode)("div", {
            class: "tab-layout-page",
            style: (0, vue_1.normalizeStyle)(_ctx.pageStyle)
        }, [
            (0, vue_1.createElementVNode)("div", _hoisted_2, [
                (0, vue_1.createVNode)(_component_router_view, null, {
                    default: (0, vue_1.withCtx)(({ Component }) => [
                        (_ctx.$route.meta.keepAlive)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(vue_1.KeepAlive, { key: 0 }, [
                                ((0, vue_1.openBlock)(), (0, vue_1.createBlock)((0, vue_1.resolveDynamicComponent)(Component)))
                            ], 1024))
                            : ((0, vue_1.openBlock)(), (0, vue_1.createBlock)((0, vue_1.resolveDynamicComponent)(Component), { key: 1 }))
                    ]),
                    _: 1
                })
            ])
        ], 4),
        (_ctx.$route.meta.unauthorized)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                key: 1,
                class: "tab-layout-main-notice tab-layout-unauthorized-notice local-main-color-danger",
                style: (0, vue_1.normalizeStyle)({ top: _ctx.headerHeight })
            }, _hoisted_4, 4))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.$route.meta.developing)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                key: 2,
                class: "tab-layout-main-notice tab-layout-developing-notice local-main-color-danger",
                style: (0, vue_1.normalizeStyle)({ top: _ctx.headerHeight, left: _ctx.siderWidth })
            }, _hoisted_6, 4))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
exports.render = render;
